import React from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";
import { BankIds } from "../../Utils/Helper.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import AddBankModal from "../../Modals/AddBankModal.js";
import DeleteBankModal from "../../Modals/DeleteBankModal.js";
import { useUser } from "contexts/userContext/userContext.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";

const BankListSettings = ({
  banksAccount,
  setBanksAccount,
  paypalAccounts,
  setPaypalAccounts,
}) => {
  const { getUserData } = useUser();
  const userData = getUserData();
  const { getTextByKey } = useContent();
  const { setModal } = useModal();
  const openAddBankModal = () => {
    setModal(() => (
      <AddBankModal
        banksAccount={banksAccount}
        setBanksAccount={setBanksAccount}
      />
    ));
  };

  const openEditBankModal = (bankId, index) => {
    const editDetails = banksAccount.find(
      (bank) => bank.BankAccountId === bankId
    );
    setModal(() => (
      <AddBankModal
        editDetails={editDetails}
        isEdit={true}
        index={index}
        banksAccount={banksAccount}
        setBanksAccount={setBanksAccount}
      />
    ));
  };
  const openDeleteBankModal = ({ type, index }) => {
    setModal(() => (
      <DeleteBankModal
        type={type}
        banksAccount={banksAccount}
        index={index}
        setBanksAccount={setBanksAccount}
        paypalAccounts={paypalAccounts}
        setPaypalAccounts={setPaypalAccounts}
      />
    ));
  };

  const changeDefaultBank = (item) => {
    if (item.defaultBank) {
      return;
    }
    const index = item.keyIndex;
    const body = {
      entryId: Number(index),
      delete: false,
      BankBranchId: item.BankBranchId,
      BankAccountId: item.BankAccountId,
      BankOwnerName: item.BankOwnerName,
      UserMail: userData.UserName,
      BankId: item.BankId,
      defaultBank: true,
    };

    setBankAsDefault(body);
  };

  const setBankAsDefault = async (body) => {
    console.log(body);
    const response = await apiRequest(
      "Users",
      "SetBankAccountDetailsReact",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        let newBanksAccount = [...banksAccount];
        //set all the banks to default false and the selected bank to true
        newBanksAccount.forEach((item) => {
          item.defaultBank = false;
        });
        const listIndex = newBanksAccount.indexOf(
          newBanksAccount.find(
            (item) => item.keyIndex === body.entryId.toString()
          )
        );
        newBanksAccount[listIndex].defaultBank = true;
        setBanksAccount(newBanksAccount);
      }
    }
  };
  return (
    <>
      {banksAccount && banksAccount.length > 0 ? (
        <div className="banks-list">
          <div className="banks-title">
            <h3>{getTextByKey("bank-accounts")}</h3>
            <div className="add-bank" onClick={() => openAddBankModal()}>
              <Icon name="plus" /> {getTextByKey("add-bank")}
            </div>
          </div>
          {banksAccount.map((item, index) => (
            <div className="bank-item" key={index}>
              <div className="image">
                <Icon name={"bank"} />
              </div>
              <div className="account-name detail">
                <div className="title-detail">
                  <span>{getTextByKey("bank-owner")}</span>
                </div>
                <div className="info-detail">
                  <span>{item.BankOwnerName}</span>
                </div>
              </div>
              <div className="bank-name detail">
                <div className="title-detail">
                  <span>{getTextByKey("bank-name-id")}</span>
                </div>
                <div className="info-detail">
                  <span>
                    {item.BankId} - {BankIds[item.BankId]}
                  </span>
                </div>
              </div>
              <div className="branch-no detail">
                <div className="title-detail">
                  <span>{getTextByKey("bank-branch")}</span>
                </div>
                <div className="info-detail">
                  <span>{item.BankBranchId} </span>
                </div>
              </div>
              <div className="account-no detail">
                <div className="title-detail">
                  <span>{getTextByKey("bank-account-id")}</span>
                </div>
                <div className="info-detail">
                  <span> {item.BankAccountId}</span>
                </div>
              </div>
              <div className="actions">
                <div
                  className="del-bank"
                  onClick={() =>
                    openDeleteBankModal({
                      type: "bank",
                      index: item.keyIndex,
                    })
                  }
                >
                  <Icon name="trash-solid-b" />
                </div>
                <div
                  className="edit-bank"
                  onClick={() =>
                    openEditBankModal(item.BankAccountId, item.keyIndex)
                  }
                >
                  <Icon name="pencil-alt-solid" />
                </div>
                <div
                  className={`set-default ${
                    item.defaultBank ? "default-bank" : ""
                  }`}
                  onClick={() => changeDefaultBank(item)}
                >
                  <Tooltip
                    id={"set-default-tooltip"}
                    tooltipTextKey={"set-default-tooltip"}
                  >
                    <Icon name="v" />
                  </Tooltip>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="bank-button" onClick={() => openAddBankModal()}>
          <Icon name="bank" />
          <span className="bank-text">
            {" "}
            <Icon name="plus" /> {getTextByKey("add-bank")}
          </span>
        </div>
      )}
    </>
  );
};

export default BankListSettings;
